export const defaultAppInfo = {
  "test-app": {
    "id": "",
    "devOnly": true,
    "hide": true,
    "name": "Test App",
    "free": true,
    "acceptsFileTransfer": true
  },
  "tx-recv-demo": {
    "id": "/mesh-rx.html",
    "name": "Mesh Receive",
    "devOnly": true
  },
  "tx-send-demo": {
    "id": "/mesh-tx.html",
    "name": "Mesh Send",
    "devOnly": true,
    "hide": true,
    "acceptsFileTransfer": false
  },


  "robotic-fingers": {
    "id": "robotic-fingers",
    "titleDictKey": "home.appcard.title.robotic-fingers",
    "titleDefaultText": "Robotic Fingers",
    "descriptionDictKey": "home.appcard.description.robotic-fingers",
    "theme": "bright",
    "category": "industrial",
    "appUrl": "apps/robotic-fingers",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Robotic-Fingertips.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/robotic-fingers",
    "free": false,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true,
    },
  },
  "clamping": {
    "id": "clamping",
    "titleDictKey": "home.appcard.title.clamping",
    "titleDefaultText": "Clamping",
    "descriptionDictKey": "home.appcard.description.clamping",
    "theme": "dark",
    "category": "industrial",
    "appUrl": "apps/clamping",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Clamping.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/clamping-jaws",
    "free": false,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true,
    },
  },
  "shadow-boards": {
    "id": "shadow-boards",
    "titleDictKey": "home.appcard.title.traysShadowBoards",
    "titleDefaultText": "Shadow-board",
    "descriptionDictKey": "home.appcard.description.traysShadowBoards",
    "theme": "dark",
    "category": "industrial",
    "appUrl": "apps/shadow-boards",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Shadow-Board.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/shadow-boards",
    "free": false,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true,
    },
  },
  "carrier-trays": {
    "id": "carrier-trays",
    "titleDictKey": "home.appcard.title.carrier-trays",
    "titleDefaultText": "Logistics Trays",
    "descriptionDictKey": "home.appcard.description.carrier-trays",
    "descriptionDefaultText": "",
    "theme": "dark",
    "category": "industrial",
    "appUrl": "apps/carrier-trays",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Logistic-Tray.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/logistics-trays",
    "free": false,
    "acceptsFileTransfer": false,
    "stickerTag": "beta",

    "visibility": {
      "staging": true,
      "production": true,
    },
    "live": true,

  },

  "outlines": {
    "id": "outlines",
    "titleDictKey": "home.appcard.title.outlines",
    "titleDefaultText": "Outline",
    "descriptionDictKey": "home.appcard.description.outlines",
    "theme": "dark",
    "category": "generic",
    "appUrl": "apps/outlines",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Photo-to-outline.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/photo-to-outline",
    "free": true,
    "acceptsFileTransfer": true,
    "categoryOrderPreference": 0,
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": true,
    },
  },
  "workpiece-creator": {
    "id": "workpiece-creator",
    "titleDictKey": "home.appcard.title.workpiece-creator",

    "titleDefaultText": "Part Sketcher",
    "descriptionDictKey": "home.appcard.description.workpiece-creator",
    "theme": "light",
    "category": "generic",
    "appUrl": "apps/workpiece-creator",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Part-Sketcher.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/part-sketcher",
    "free": true,

    "acceptsFileTransfer": true,
    "visibility": {
      "staging": true,
      "production": true,
    },
    "stickerTag": "beta"
  },
  "workpiece-modifier": {
    "id": "workpiece-modifier",
    "titleDictKey": "home.appcard.title.workpiece-modifier",
    "titleDefaultText": "Workpiece Modifier",
    "descriptionDictKey": "home.appcard.description.workpiece-modifier",
    "theme": "light",
    "category": "generic",
    "appUrl": "apps/workpiece-modifier",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Part-Modifier.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/part-modifier",
    "free": true,
    "acceptsFileTransfer": true,
    "stickerTag": "beta",

    "visibility": {
      "staging": true,
      "production": true,
    },

  },
  "stabilizers": {
    "id": "stabilizers",
    "titleDefaultText": "Stabilizers",
    "titleDictKey": "home.appcard.title.stabilizers",

    "descriptionDictKey": "home.appcard.description.stabilizers",
    "theme": "dark",
    "category": "free",

    "appUrl": "apps/stabilizers",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Bottle Holder.jpg",
    "detailsPageURL": "https://www.trinckle.com/apps/stabilizers",
    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": false,
    },
    "free": true,
    "acceptsFileTransfer": true
  },

  "freeform-labels": {
    "id": "freeform-labels",

    "titleDefaultText": "Freeform Labels",
    "titleDictKey": "home.appcard.title.freeform-labels",
    "descriptionDictKey": "home.appcard.description.freeform-labels",
    
    "theme": "bright",

    "appUrl": "apps/freeform-labels",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Free-form-label.jpg",
    "detailsPageURL": "https://apps.trinckle.com/apps/freeform-labels/",
    
    "acceptsFileTransfer": true,
    "stickerTag": "beta",
    
    "category": "free",
    "free": true,

    "visibility": {
      "staging": true,
      "production": false,
    },
    "live": true,
  },
  "protective-plugs": {
    "id": "protective-plugs",

    "titleDictKey": "home.appcard.title.protective-plugs",
    "titleDefaultText": "Protective Plugs",
    "descriptionDictKey": "home.appcard.description.protective-plugs",

    "category": "free",
    "free": true,

    "theme": "dark",


    "appUrl": "apps/protective-plugs",
    "backgroundImage": "assets/img/app-cards/gradient/jpg/Paint-Plugs.jpg",
    "detailsPageURL": "https://apps.trinckle.com/apps/protective-plugs/",

    "stickerTag": "beta",
    "visibility": {
      "staging": true,
      "production": false,
    },

    "acceptsFileTransfer": true,
    "live": true,
  }
}
